import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({ breakpoints, borderRadiuses, palette }: Theme) => ({
  apps: {
    display: 'flex',
    width: 'fit-content',
    gap: '0.75rem',
    [breakpoints.up('md')]: {
      alignSelf: 'flex-end',
    },
    [breakpoints.up('xl')]: {
      alignSelf: 'flex-start',
    },
  },
  stores: {
    display: 'flex',
    gap: '0.5rem',
    width: 'fit-content',
    height: '100%',
    flexDirection: 'column',
    listStyle: 'none',
    margin: 0,
    padding: 0,
    '& a': {
      display: 'block',
      lineHeight: 0,
    },
  },
  icon: {
    width: 135,
    height: 'auto',
  },
  qrCode: {
    padding: '0.25rem',
    width: 88,
    height: 88,
    borderRadius: borderRadiuses.md,
    background: palette.common.white,
    '& img': {
      display: 'block',
      width: '100%',
      height: 'auto',
      objectFit: 'contain',
    },
  },
}));
